module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAAEF7NTqAAAAAXNSR0IArs4c6QAAANFJREFUKBWNUcENwjAMjKN+EO+yAmUJ6BIsAfPQ7gBLwIMdYAX6hvKKyUW5KrQFNVJk3/nOcV2zPDzV8BTV6xrywHYIFEBHpKaQk2Bkw15kGVEiaO77+YI6zz18nhOPxr9OFo1vK7DzzUzEliB4vnBRt6WqCm5RtRuKfscxhw1WNSoi4cIOLlN159grTEXMcRs/zfa2m12iaBDQxZtOvpBbVLk2rKw/MXBcZacbdMSnpmQfoxZeSkVTcsuVc4xV/V6nRuB0bOinLwJ/yrmjb5h/AP0plO+r7oLZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/expand.png
// module id = /Wu+
// module chunks = 0